import styled from 'styled-components'

export const MainContainer = styled.div`
  max-width: 800px;

  hr {
    margin: ${({ theme }) => `${theme.spacings[6]} 0`};
  }
`
